import type { ReactNode } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../hooks/useTheme';
import Spinner from '../ui/Spinner/Spinner';

/**
 * Wraps routes that require authentication.
 * Shows a full-screen spinner while validating, then either
 * renders children or triggers the Cognito redirect.
 */
export default function AuthGuard({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated, login } = useAuth();
  // Sync the user's saved theme from DB as soon as auth is confirmed.
  // isAuthenticated transitions false→true once, triggering a single GET /api/users/details.
  useTheme(isAuthenticated);

  if (isLoading) {
    return <Spinner overlay text="Authenticating…" />;
  }

  if (!isAuthenticated) {
    login();
    return <Spinner overlay text="Redirecting to login…" />;
  }

  return <>{children}</>;
}
